// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_qaDDN6k5","label":"_ybyeMm5L","value":"_9PykvJDF"};